import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Container, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { createApplicationAction } from "../../../redux/actions/ApplicationAction";
import notify from "../../../Notifcation";
import { useNavigate } from "react-router-dom";

const Ashkhal = () => {
  const [desc, setdesc] = useState("");
  const [Nationalid, setNationalid] = useState("");
  const [Lecshop, setLecshop] = useState("");
  const [akdtanazol, setakdtanazol] = useState("");
  const [Esaldall, setEsaldall] = useState("");
  const [Nationalidtanazol, setNationalidtanazol] = useState([]);
  const [EngDrawQoroqe, setEngDrawQoroqe] = useState("");
  const [TwoMahder, setTwoMahder] = useState("");
  const [Mostanedusfel, setMostanedusfel] = useState("");
  const [Taxcard, setTaxcard] = useState("");
  const [SADADMOKH, setSADADMOKH] = useState("");
  const [Notify, setNotify] = useState("");

  const [ChoseServ, setChoseServ] = useState("");

  const [Others, setOthers] = useState([]);
  const navegate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [isPress, setisPress] = useState(false);
  const handleFileChangeNational = (e) => {
    // Convert FileList to Array
    const files = Array.from(e.target.files);
    setNationalid(files);
  };
  const handleFileChangeNationailidtanazol = (e) => {
    // Convert FileList to Array
    const files = Array.from(e.target.files);
    setNationalidtanazol(files);
  };
  const handleFileChangeOther = (e) => {
    // Convert FileList to Array
    const files = Array.from(e.target.files);
    setOthers(files);
  };
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (Nationalid === "" ) {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setisPress(true);
    const formData = new FormData();
    formData.append("application_type", 7);
    formData.append("local_type", 3);
    formData.append("local_category", ChoseServ);
    formData.append("local_details", desc);
    formData.append("receipt_proving_payment_of_fees", Esaldall);
    formData.append(
      "engineering_or_sketch_drawing_of_works_site",
      EngDrawQoroqe
    );
    formData.append("tax_card", Taxcard);
    formData.append("license", Lecshop);
    formData.append("license_waiver_contract", akdtanazol);
    formData.append("copy_of_report_detailing_seizures", TwoMahder);
    formData.append(
      "document_proving_ownership_of_seized_items",
      Mostanedusfel
    );
    formData.append("value_of_paying_the_violation", SADADMOKH);
    formData.append("notification_of_violation_report", Notify);
    Nationalid.map((item) => {
      return formData.append("client_national_ids", item);
    });
    Nationalidtanazol.map((item) => {
      return formData.append("assigned_national_identification_number", item);
    });
    Others.map((item) => {
      return formData.append("others", item);
    });
    await dispatch(createApplicationAction(formData));
    setLoading(false);
    setisPress(false);
    setdesc("");
    setNationalid("");
    setTaxcard("");
    setChoseServ("");
    setLecshop("");
    setEsaldall("");
    setOthers("");
  };
  const res = useSelector((state) => state.ApplicationReduser.createApp);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 1500);
      if (res) {
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            notify(res.data.message, "success");
            setTimeout(() => {
              navegate("/user/requestsuser");
            }, 3000);
          }
        } else if (res.status !== 201 || res.status !== 200) {
          if (res.data) {
            notify(res.data.message, "error");
          } else {
            notify("حدثة مشكلة حاول مرة اخرى", "error");
          }
        }
      }
    }
  }, [loading]);
  return (
    <Container>
      {" "}
      <h3 className="text-center mb-3 mt-3">خدمات الأشغالات</h3>
      <div className="inputs-container">
        <div className="inp-container">
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              {
                <Typography>
                  نوع الخدمة
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label={
                <Typography>
                  نوع الخدمة
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
              value={ChoseServ}
              onChange={(e) => setChoseServ(e.target.value)}
            >
              <MenuItem value={11}>طلب ترخيص اشغال طريق</MenuItem>
              <MenuItem value={12}>طلب نقل رخصة اشغال طريق</MenuItem>
              <MenuItem value={13}>طلب الغاء رخصة اشغال طريق</MenuItem>
              <MenuItem value={31}>طلب تجديد رخصة اشغال طريق</MenuItem>
              <MenuItem value={32}>طلب استرداد مضبوطات اشغال طريق</MenuItem>
              <MenuItem value={33}>
                طلب استخراج ما يفيد سداد مخالفات اشغال الطريق
              </MenuItem>
            </Select>
          </FormControl>
        </div>
        {ChoseServ === 11 ? (
          <>
            {" "}
            <div className="inp-container ">
              <TextField
                label={
                  <Typography>
                    البطاقة الشخصية
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                focused
                inputProps={{
                  multiple: true,
                }}
                type="file"
                onChange={handleFileChangeNational}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"الإيصال الدال على سداد رسم نظر مستوفياً الدمغة"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setEsaldall(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"صورة ترخيص المحل"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setLecshop(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"رسم هندسي او كروكي لموقع الاشغال"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setEngDrawQoroqe(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"صورة البطاقة الضريبية"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setTaxcard(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"تفاصيل"}
                multiline
                type="text"
                value={desc}
                onChange={(e) => {
                  setdesc(e.target.value);
                }}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"اخرى"}
                focused
                inputProps={{
                  multiple: true,
                }}
                type="file"
                onChange={handleFileChangeOther}
                variant="outlined"
              />
            </div>
          </>
        ) : ChoseServ === 12 ? (
          <>
            {" "}
            <div className="inp-container ">
              <TextField
                label={
                  <Typography>
                    البطاقة الشخصية
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                focused
                inputProps={{
                  multiple: true,
                }}
                type="file"
                onChange={handleFileChangeNational}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"الإيصال الدال على سداد رسم نظر مستوفياً الدمغة"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setEsaldall(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"رخصة اشغال الطريق الصادرة"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setLecshop(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={
                  "عقد تنازل عن الترخيص بالاشغالات من المتنازل الي المتنازل الية"
                }
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setakdtanazol(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"صورة بطاقة الرقم القومي للمتنازل والمتنازل الية"}
                focused
                inputProps={{
                  multiple: true,
                }}
                type="file"
                onChange={handleFileChangeNationailidtanazol}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"تفاصيل"}
                multiline
                type="text"
                value={desc}
                onChange={(e) => {
                  setdesc(e.target.value);
                }}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"اخرى"}
                focused
                inputProps={{
                  multiple: true,
                }}
                type="file"
                onChange={handleFileChangeOther}
                variant="outlined"
              />
            </div>
          </>
        ) : ChoseServ === 13 ? (
          <>
            <div className="inp-container ">
              <TextField
                label={
                  <Typography>
                    البطاقة الشخصية
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                focused
                inputProps={{
                  multiple: true,
                }}
                type="file"
                onChange={handleFileChangeNational}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"صورة الرخصة"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setLecshop(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"تفاصيل"}
                multiline
                type="text"
                value={desc}
                onChange={(e) => {
                  setdesc(e.target.value);
                }}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"اخرى"}
                focused
                inputProps={{
                  multiple: true,
                }}
                type="file"
                onChange={handleFileChangeOther}
                variant="outlined"
              />
            </div>
          </>
        ) : ChoseServ === 31 ? (
          <>
            <div className="inp-container ">
              <TextField
                label={
                  <Typography>
                    البطاقة الشخصية
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                focused
                inputProps={{
                  multiple: true,
                }}
                type="file"
                onChange={handleFileChangeNational}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"صورة ترخيص المحل"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setLecshop(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"رسم هندسي او كروكي لموقع الاشغال"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setEngDrawQoroqe(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"صورة البطاقة الضريبية"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setTaxcard(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"الرخصة او الإيصال الدال على سداد الرسوم"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setEsaldall(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"تفاصيل"}
                multiline
                type="text"
                value={desc}
                onChange={(e) => {
                  setdesc(e.target.value);
                }}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"اخرى"}
                focused
                inputProps={{
                  multiple: true,
                }}
                type="file"
                onChange={handleFileChangeOther}
                variant="outlined"
              />
            </div>
          </>
        ) : ChoseServ === 32 ? (
          <>
            {" "}
            <div className="inp-container ">
              <TextField
                label={
                  <Typography>
                    البطاقة الشخصية
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                focused
                inputProps={{
                  multiple: true,
                }}
                type="file"
                onChange={handleFileChangeNational}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"صورة المحضر ببيان المضبوطات المتحفظ عليها"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setTwoMahder(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"مستند يفيد ملكية هذه المضبوطات"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setMostanedusfel(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"الإيصال الدال على سداد الرسوم المطلوبة"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setEsaldall(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"تفاصيل"}
                multiline
                type="text"
                value={desc}
                onChange={(e) => {
                  setdesc(e.target.value);
                }}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"اخرى"}
                focused
                inputProps={{
                  multiple: true,
                }}
                type="file"
                onChange={handleFileChangeOther}
                variant="outlined"
              />
            </div>
          </>
        ) : ChoseServ === 33 ? (
          <>
            <div className="inp-container ">
              <TextField
                label={
                  <Typography>
                    البطاقة الشخصية
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                focused
                inputProps={{
                  multiple: true,
                }}
                type="file"
                onChange={handleFileChangeNational}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"قيمة سداد المخالفة او صورة لها"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setSADADMOKH(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"اخطار بمحضر المخالفة او صورة منها"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setNotify(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"تفاصيل"}
                multiline
                type="text"
                value={desc}
                onChange={(e) => {
                  setdesc(e.target.value);
                }}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"اخرى"}
                focused
                inputProps={{
                  multiple: true,
                }}
                type="file"
                onChange={handleFileChangeOther}
                variant="outlined"
              />
            </div>
          </>
        ) : null}

        <div className="inp-container "></div>
        <div className="inp-container "></div>
      </div>
      {isPress && loading ? (
        <button className="buttonadd">
          <Spinner />
        </button>
      ) : (
        <button className="buttonadd" onClick={handlesubmit}>
          {" "}
          استكمال الطلب
        </button>
      )}
      <ToastContainer />
    </Container>
  );
};

export default Ashkhal;
